import { Heart, Briefcase, Users, Sparkles, Martini } from "lucide-react";
import { SectionLabel, FadeUp } from "@/components/Reveal";
import { scrollToHash } from "@/lib/scroll";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Heart, Briefcase, Users, Sparkles, Martini];

const Services = () => {
  const { t } = useLang();
  const pre = t.services.pre.split("\n");
  return (
  <section id="services" data-testid="services-section" className="bg-midnight">
    <div className="mx-auto max-w-[1680px] px-6 py-20 lg:px-12 lg:py-32">
      <SectionLabel index="02" text={t.services.label} />
      <div className="mt-8 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <FadeUp delay={0.1}>
          <h2 className="max-w-2xl font-serif text-4xl font-light leading-[1.1] text-ivory md:text-5xl lg:text-6xl">
            {pre[0]}
            <br />
            {pre[1]}<span className="italic text-gold">{t.services.em}</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="max-w-sm font-sans text-sm font-light leading-relaxed text-ivory/50">
            {t.services.sub}
          </p>
        </FadeUp>
      </div>

      <div className="mt-16 grid gap-px bg-gold/10 md:grid-cols-2 lg:grid-cols-6">
        {t.services.items.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <FadeUp
              key={s.title}
              delay={i * 0.08}
              className={i < 3 ? "lg:col-span-2" : "lg:col-span-3"}
            >
              <div
                data-testid={`service-card-${["weddings","corporate-events","private-parties","holiday-parties","cocktail-experiences"][i]}`}
                className="group flex h-full flex-col bg-midnight p-7 transition-colors duration-500 hover:bg-charcoal lg:p-12"
              >
                <Icon
                  size={28}
                  strokeWidth={1}
                  className="text-gold transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="mt-6 font-serif text-xl font-light tracking-wide text-ivory lg:mt-10 lg:text-2xl">
                  {s.title.toUpperCase()}
                </h3>
                <p className="mt-3 font-sans text-sm font-light leading-relaxed text-ivory/50 lg:mt-4">
                  {s.desc}
                </p>
                <span className="mt-5 block h-px w-8 bg-gold/40 transition-all duration-500 group-hover:w-16 group-hover:bg-gold lg:mt-8" />
              </div>
            </FadeUp>
          );
        })}
      </div>

      <FadeUp delay={0.2} className="mt-14">
        <button
          onClick={() => scrollToHash("#packages")}
          data-testid="services-view-packages-btn"
          className="border border-gold/50 px-10 py-4 font-sans text-[11px] tracking-[0.3em] text-gold transition-colors duration-300 hover:bg-gold hover:text-midnight"
        >
          {t.services.cta}
        </button>
      </FadeUp>
    </div>
  </section>
  );
};

export default Services;
